
<div class="text-start m-3 confirmation-dialog-container"  >
    <i class="ri-close-line" (click)="close(false)"></i>
  </div>
  <div class="text-center " >
    <i class="ri-information-line   font-size-6rem"></i>
  </div>
  <div class="text-center pt-4">
    <h3 *ngIf="data.title">{{data.title}}</h3>
      <p class="text-dark">{{data.message}}</p>
      <div class="w-100 d-flex justify-content-center p-3 mt-3">
        <button id="btn_search" class="btn  dangers_small_btn mx-3" [disabled]="isClosing" (click)="close(false)" >{{data.falseText }}</button>
        <button id="btn_search" class="btn btn-danger dangers_small_btn" [disabled]="isClosing" (click)="close(true)" >{{data.trueText }}</button>
        </div>
  </div>
